module.exports = __webpack_public_path__ + "img/2@2x.c6effac1.png";